import { useState } from 'react';

import { FinancialIncomeReportSubHeader } from './components';
import { FinancialIncomeReportLayout } from './layout';
import { useIncomeReportPrint } from './hooks';
import { getLastYears } from './utils/getLastYears';

export function FinancialIncomeReportPage() {
  const years = getLastYears(4);

  const [selectedYearLocal, setSelectedYearLocal] = useState<string>(years[0]);
  const [yearToQuery, setYearToQuery] = useState<string>(years[0]);

  const { incomeReportPrintState, refreshIncomeReportPrint } =
    useIncomeReportPrint(Number(yearToQuery));

  const handleFetch = () => {
    setYearToQuery(selectedYearLocal);
    refreshIncomeReportPrint();
  };
  return (
    <>
      <FinancialIncomeReportSubHeader
        selectedYear={selectedYearLocal}
        setSelectedYear={setSelectedYearLocal}
        isLoading={incomeReportPrintState.isLoading}
        onFetch={handleFetch}
        data={incomeReportPrintState.data}
        lastYearFetched={yearToQuery}
      />
      <FinancialIncomeReportLayout
        data={incomeReportPrintState.data}
        isLoading={incomeReportPrintState.isLoading}
        isError={incomeReportPrintState.isError}
        onReloadClick={refreshIncomeReportPrint}
      />
    </>
  );
}
